import { Box } from '@chakra-ui/react'
import BlogPostTable from './components/BlogPostTable'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <BlogPostTable />
    </Box>
  )
}
